import { render, staticRenderFns } from "./ReadAloudOverview.vue?vue&type=template&id=28d577b8&scoped=true&"
import script from "./ReadAloudOverview.vue?vue&type=script&lang=js&"
export * from "./ReadAloudOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudOverview.vue?vue&type=style&index=0&id=28d577b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d577b8",
  null
  
)

export default component.exports